import { MbeRightArrow } from '@/components/icons';
import type { FlexProps, HeadingProps } from '@chakra-ui/react';
import { Box, Button, Icon, Flex, Heading } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

interface ISectionProps {
  children: React.ReactNode;
  containerProps?: FlexProps;
  headingProps?: HeadingProps;
  id: string;
  path?: string;
  title?: string;
  titleOnShowAll?: string;
}

export const Section: React.FC<ISectionProps> = (props): JSX.Element => {
  const {
    children,
    id,
    title,
    headingProps = {},
    containerProps = {},
    titleOnShowAll,
    path,
  } = props;

  const cta = path ? (
    <NavLink to={path}>
      <Button color="brand.red.light" px={2} variant="link">
        <Flex alignItems="center" gap={4}>
          {titleOnShowAll}
          <Icon as={MbeRightArrow} h={10} w={10} />
        </Flex>
      </Button>
    </NavLink>
  ) : (
    ''
  );

  return (
    <Flex direction="column" gap={6} id={id} justifyContent="center" {...containerProps}>
      <Flex alignItems="center" justifyContent="space-between">
        <Heading
          as="h1"
          fontSize={{ base: '24px', md: 'h2.md' }}
          fontWeight="bold"
          textAlign="center"
          {...headingProps}
        >
          {title}
        </Heading>
        {path && <Box display={{ base: 'none', md: 'block' }}>{cta}</Box>}
      </Flex>
      {children}

      {path && (
        <Flex justifyContent="flex-end">
          <Box display={{ base: 'block', md: 'none' }}>{cta}</Box>
        </Flex>
      )}
    </Flex>
  );
};
